import React, { useEffect, useState } from 'react';
import success from '../../Components/assets/images/thankyou.gif';
import error from '../../Components/assets/images/error.gif';
import '../../Components/assets/css/verify.css'
import { VERIFY_USER } from '../../services/Url';
import { verifyUserPost } from '../../services/Service';
import { useParams } from 'react-router-dom';

export const VerifyUser = () => {
  const params = useParams();
  const [data, setData] = useState();
  const completeUrl = VERIFY_USER + "/" + params?.tokenId;
  const pathName = window?.location?.pathname

  useEffect(() => {
    verifyUserPost(completeUrl, setData);
  }, [pathName]);

  console.log('data', data)

  console.log(completeUrl, pathName, data, ">>>>>>");
  return (
    <div className='userVrf_wpr'>
      {
        data?.response === 'error' ?
          <div className='useVrf_bx text-center'>
            <img width="120" height="120" src={error} alt="error" />
            Sorry ! Your Email Is Not Verified
          </div> :
          data?.response === 'Url Expired.' ?
            <div className='useVrf_bx text-center'>
              <img width="120" height="120" src={error} alt="error" />
              Sorry, The link has expired. Please go back to the app and reregister to receive a new verification email
            </div> :
            data?.response === 'Already Verified.' ?
              <div className='useVrf_bx text-center'>
                <img width="120" height="120" src={success} alt="error" />
                Your Email Is Already Verified
              </div> : data?.response === 'Verify Successfully.' ?
                <div className='useVrf_bx text-center'>
                  <img width="120" height="120" src={success} alt="error" />
                  Thanks for verifying your account. Please head back to the app to sign in to your account.
                </div> : ''
      }
    </div>
  )
}
